import React, { FC, memo } from 'react';
import { Button } from '@src/atoms/Button';
import { useLegoV2Context } from '../../hooks';
import { Box } from '@src/atoms/Box';

export const LegoElementButton: FC<Parameters<typeof Button>[0] & { isSubmit?: boolean }> = memo((props) => {
  const { onSubmit } = useLegoV2Context();

  return <Button size="md" onClick={props.isSubmit ? onSubmit : undefined} {...props} />;
});

/** Элемент с двумя кнопками, левая из которых является submit */
export const LegoElementSubmitButtons: FC<{
  submitBtnProps: Parameters<typeof Button>[0];
  cancelBtnProps: Parameters<typeof Button>[0];
}> = memo(({ submitBtnProps, cancelBtnProps }) => {
  const { onSubmit } = useLegoV2Context();

  return (
    <Box gap={4} fullWidth justifyContent="spaceBetween" alignItems="center" paddingTop={{ DESKTOP: 12, MOBILE: 20 }}>
      <LegoElementButton onClick={onSubmit} size="md" {...submitBtnProps} />
      <LegoElementButton view="textLight" size="md" {...cancelBtnProps} />
    </Box>
  );
});
